import { createAsyncTypes } from 'utils/ActionCreator'

export const CUSTOMIZATION_REQUEST_ASYNC = createAsyncTypes(
  'GENERAL_SETTINGS_REQUEST',
  'Settings/Customization'
)
export const UPDATE_CUSTOMIZATION_REQUEST = createAsyncTypes(
  'UPDATE_CUSTOMIZATION_REQUEST',
  'Settings/Customization'
)
export const LANGUAGE_CHANGE = 'Settings/Customization/LANGUAGE_CHANGE'
